module.exports = __webpack_public_path__ + "img/support.2b4557f9.svg";